
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Zubereitung',
    showminies: true,
    showmedia: false,
    vuexnamespace: 'preparations',
    initmutation:'preparations/PREPARATION_INIT_PREPARATION',
    backlink:'supplier',
    duplicateable:true,
    helptext:"Hier werden die Zubereitungen eingegeben. Diese können auch 'on-the-fly' während der Eingabe der \n\
            Rezeptschritte eingegeben werden. <br><br> Der goldene Haken dient der Speicherung. Mit dem schwarzen Kreuz\n\
            wird ohne zu speichern das Formular verlassen. Mit dem Doppelhaken wird der Datensatz dupliziert."
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};